<template>
  <div class="animated fadeIn">
    <slot name="before-pills" />
    <context-pill
      v-for="(item, index) in items"
      :key="index"
      :disabled="item.disabled"
      :variant="item.variant"
      :to="item.to"
      :onClick="item.onClick"
      :onHover="item.onHover"
      :faIcon="item.faIcon"
      :label="item.label"
    />
    <slot name="after-pills" />
  </div>
</template>

<script>
import ContextPill from "./ContextPill";
export default {
  name: "ContextPills",
  components: { ContextPill },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
